// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container__3j-Tp {\n    display: flex;\n    align-items: center;\n    background: white;\n    border-top: 1px solid #f2f2f2;\n    box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.14);\n    overflow: hidden;\n    transition: height 1.3s ease;\n    font-size: 16px;\n    line-height: 18px;\n    padding: 5px 24px 5px 16px\n}\n\n.iconContainer__OIWoJ {\n    font-size: 20px;\n}\n\n.messageContainer__1zhh0 {\n    flex-grow: 1;\n    padding: 0 20px;\n}\n\n.actionsContainer__3ULY5 { }\n\n.ctaButton__FL4Xh {\n    margin-right: 5px;\n}", ""]);
// Exports
exports.locals = {
	"container": "container__3j-Tp",
	"iconContainer": "iconContainer__OIWoJ",
	"messageContainer": "messageContainer__1zhh0",
	"actionsContainer": "actionsContainer__3ULY5",
	"ctaButton": "ctaButton__FL4Xh"
};
module.exports = exports;
